<template>
  <div class="yx-predicted-page main-layout predicted-item-page" v-loading="handleLoading">
    <el-card shadow="never" class="box-form box-inner box-bg">
      <c-title slot="header" title="高考成绩"></c-title>
      <div class="pb90">
        <div class="div-scroll">
          <el-form
            size="small"
            :model="handleData"
            ref="cForm"
            :rules="formRules"
            label-position="top"
            style="width: 60%; margin: 0 auto; padding-top: 40px"
            :disabled="disabled"
          >
            <el-form-item label="高考成绩：" prop="subject">
              <el-input
                :rows="8"
                v-model="handleData.subject"
                type="textarea"
                maxlength="200"
                show-word-limit
                placeholder="请输入高考成绩,200字以内"
              ></el-input>
            </el-form-item>

            <el-form-item label-width="0">
              <div style="text-align: center; padding-top: 20px">
                <el-button type="primary" class="leave-btn" @click="submit" :disabled="disabled"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MHandle from "@/mixins/MHandle.js";
let mHandle = MHandle({
  handleGetPath: "",
  handleGetPathNoparam: "/account/base/student/grade/myInfo",
  handleInsertPath: "/account/base/student/grade/save",
  handleUpdatePath: "/account/base/student/grade/update",
  handleDownLoadPath: "",
  handleData: {},
});

export default {
  mixins: [mHandle],
  data() {
    return {
      formRules: {
        subject: [
          {
            required: true,
            trigger: "blur",
            message: "请输入",
          },
        ],
      },
      defaultHandleData: {
        art: "",
        highSchoolCulture: "",
        highSchoolMajor: "",
        liberalArts: "",
        other: "",
        science: "",
        studentId: "",
        subject: "",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  created() {
    this.handleData = Object.assign({}, this.defaultHandleData);
  },
  mounted() {
    this.getInfo(); //查询个人信息
  },
  methods: {
    // 获取学生到校信息
    getInfo() {
      this.$http.get("/account/base/student/grade/myInfo").then((res) => {
        // console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          if (res.data) this.handleData = res.data;
        } else {
          this.$message.error(`${res.msg}`);
        }
      });
    },
    submit() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.$confirm("请确认无误后提交，是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            if (this.handleData.id) {
              this.handleUpdate();
            } else {
              this.handleInsert();
            }
          });
        }
      });
    },
  },
};
</script>

